import { Screen } from '~/screens/clients/[id]';

export const ClientsShow = () => <Screen />;
